export const songLinks = {
  "before i wake" : [
        
        "https://open.spotify.com/track/5DCxmJGKS4PqspU66owl6t?si=jw8ETPqNSRiAwFxEVlxIzA",
        "https://soundcloud.com/hendricksxn/before-i-wake"
        ],  
        "FAUST": [
          
          "",
          "https://soundcloud.com/hendricksxn/faust"
        ],
        "RUN": [
          
          "",
          "https://soundcloud.com/hendricksxn/run-ambedo-excerpt-0103?in=hendricksxn/sets/ambedo-ost"

        ],
        "+BRIIIIIIITE": [
         
          "",
          "",
        ],
        "48 Subs": [
           
            "https://open.spotify.com/track/1ISzPyX6ZRITNVgJcRT7EV?si=RzFZawaKTRG-M7WiPe8y6g",
            "https://soundcloud.com/maxmcphatter/48-subs-feat-noturlover",
        
          ],
        "Hurry Up": [
            
            "https://open.spotify.com/track/3iYa0HYjFd5gQpXRLcS1Bm?si=Qly5suCLSfaA3wbWm6OR2A",
            "https://soundcloud.com/maxmcphatter/hurry-up",
          ],
        "RESTART": [
            
            "https://open.spotify.com/track/5XzXH5ANZYbaeW5WhZs1fy?si=Z5eYtuARSRmv5GNGSYMWPw",
            "https://soundcloud.com/maxmcphatter/restart",
          
            
          ],
        "Tangerine":
          [
              "https://open.spotify.com/track/732Dv9AhXAkkNuS0qAf3Si?si=mwqHX_VKR3iLNqQBBGvthQ",
              "https://soundcloud.com/chaisully/tangerine",
             
            ],

            "vexed.": [
              
              "",
              "https://soundcloud.com/jnjkhaira/vexed",
              
            ],
            
            "blundell.": [
             
              "",
              ""
          
            ],
            "earth strong.": [
             
              "",
              ""
            ],
            "humdila": [
              
              "",
              ""
          
            ],

            "Slide": [
             
              "https://open.spotify.com/track/0xCAcwmFdDQc0bBow5LuI0?si=Q6tuNWfzTGS6Zdxf4SyjhA",
              "https://soundcloud.com/noturlover/slide-noturlover-p-bakedboi"
            ],
            "Ayana": [
             
              "https://open.spotify.com/track/6Wvl3Oz0NmjKnIzERkT9TU?si=TIU3DMNmTDq66Xug50tCzw",
              "https://soundcloud.com/noturlover/ayana",
            ],
            "Mood Right": [
             
              "https://open.spotify.com/track/2iSXAYiiYGoivuc6Xy4bcF?si=A0oVWT_uRDmOmgHWLM7kCQ",
              "https://soundcloud.com/noturlover/mood-right-prod-by-svnred",
            ],
 
            "97'": [
              
              "",
              "https://soundcloud.com/rodlowkey26/97-feat-art-of-max-prod-juno"
        
          
            ],
            "Hip Hop": [
             
              "",
              "https://soundcloud.com/rodlowkey26/hip-hop-feat-drazi-prod-teklun",
      
            ],
            "Speak Yo": [
             
              "",
              "https://soundcloud.com/rodlowkey26/speak-yo-shit-prod-ahwlee-dimijay",
      
            ],
            "Babies and Fools": [
             
              "",
              "https://soundcloud.com/rodlowkey26/babies-and-fools-rod-mix",
      
            ],
            "Smooth": [
             
              "",
              "",
      
            ],

            "Like Me Now": [
              
              "",
              ""
            ],
            "bloom interlude": [
             
              "",
              "https://soundcloud.com/iselahi/bloom-interludemp3",
            
            ],
     
            "Audrey": [
             
              "https://open.spotify.com/track/1pdJp0t28rZE2gSvDHmEVE?si=J6Ba5tB8Q1C85UbKTYMkEQ",
              ""
            ],
            "Fool": [
              
              "https://open.spotify.com/track/3opT4yyRDKIU2XCjKVm0wK?si=nJ79BDA0Tm-gjIXHG53cMQ",
              "",
           
            ],

            "charms": [
           
            "",
            "https://soundcloud.com/hunter516/charms",
           
          ],
          "bloo": [
            "",
            "https://soundcloud.com/hunter516/bloo",
            
          ],
          "Jerry n Georgie": [
            "",
            "https://soundcloud.com/hunter516/raleighmatt-jerry-n-georgie",
           
          ],

          "Fish Out of Water":
          [
            "https://open.spotify.com/track/3SQ0RUxO4A0mkeJckeR7JB?si=dNOhxEexSJSRP3blwUZcPg",
            ""
          ],
          "Gamma Riders":[
            
            "",
            "https://soundcloud.com/purplecorp/gamma-riders",
            
          ],

}
